var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagenotfound"},[_c('h1',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('img',{staticStyle:{"max-width":"100%","max-height":"100%"},attrs:{"src":_vm.rand_img}}),_c('br'),_vm._v(" I think one of us failed... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }